var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/flex.ts
import "@adornis/buildify/client/components/x-buildify-spacing-picker.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/popover/x-dropdown-selection";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { FLEX_KEY, FLEX_SCHEMA } from "../../schema/nodes/flex.js";
import { PARAGRAPH_KEY } from "../../schema/nodes/paragraph.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
import { boxEditor } from "./box.js";
var flexEditor = ({
  content,
  contentController,
  controllerBaseKeyPath,
  host
}) => {
  return html`
    <x-flex space="sm">
      <x-buildify-spacing-picker
        select
        clearable
        placeholder="Zeilen-Abstand"
        select
        ${contentController.field(...controllerBaseKeyPath, "rowGap")}
      ></x-buildify-spacing-picker>
      <x-buildify-spacing-picker
        select
        clearable
        placeholder="Spalten-Abstand"
        select
        ${contentController.field(...controllerBaseKeyPath, "columnGap")}
      ></x-buildify-spacing-picker>
      <x-dropdown-selection
        clearable
        placeholder="Richtung"
        .selectables=${["row", "column"]}
        ${contentController.field(...controllerBaseKeyPath, "flexDirection")}
        .renderString=${(str) => str ? { row: "Horizontal", column: "Vertikal" }[str] ?? "" : ""}
      ></x-dropdown-selection>
      <x-dropdown-selection
        clearable
        placeholder="Anordnung entlang der Richtung"
        .selectables=${["flex-start", "center", "flex-end", "space-between", "space-around"]}
        ${contentController.field(...controllerBaseKeyPath, "justifyContent")}
      ></x-dropdown-selection>
      <x-dropdown-selection
        clearable
        placeholder="Anordnung entgegen der Richtung"
        .selectables=${["flex-start", "center", "flex-end", "space-between", "space-around", "stretch"]}
        ${contentController.field(...controllerBaseKeyPath, "alignItems")}
      ></x-dropdown-selection>

      ${boxEditor({
    content,
    // @ts-expect-error its the same class
    contentController,
    controllerBaseKeyPath,
    host
  })}
    </x-flex>
  `;
};
var flex = () => ({
  node: {
    name: FLEX_KEY,
    schema: FLEX_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: "Flex",
      icon: "flex_wrap",
      run: (view) => runInsertNode(FLEX_KEY, (state) => {
        return {
          content: [state.schema.nodes[PARAGRAPH_KEY].create()]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor: flexEditor
});
var NodeFlex = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-flex
        ${css({
      padding: content?.padding,
      border: mode === "edit" ? `1px solid ${this.colors.accent.shade(200)}` : "none",
      boxSizing: "border-box",
      background: content?.getBackgroundColorParsed(),
      borderRadius: content?.borderRadius ?? "unset",
      flexDirection: content?.flexDirection ?? "",
      justifyContent: content?.justifyContent ?? "",
      alignItems: content?.alignItems ?? "",
      rowGap: content?.rowGap ?? "16px",
      columnGap: content?.columnGap ?? "",
      height: "100%",
      overflow: "hidden"
    })}
      >
        <slot></slot>
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          height: this._data.value?.height ?? ""
        },
        "::slotted(*:not(:first-child):not(:last-child))": { marginBlock: "unset !important" },
        "::slotted(:first-child:not(:last-child))": { marginBlockEnd: "unset !important" },
        "::slotted(:last-child:not(:first-child))": { marginBlockStart: "unset !important" }
      }
    ];
  }
};
NodeFlex = __decorateClass([
  customElement("node-flex")
], NodeFlex);
export {
  NodeFlex,
  flex,
  flexEditor
};
